export const loadHubspotChat = () => {
  if (document.getElementById('hs-script-loader')) return

  try {
    console.log('loading hubspot chat')
    const script = document.createElement('script')
    script.id = 'hs-script-loader'
    script.src = '//js-eu1.hs-scripts.com/145710253.js'
    script.setAttribute('defer', 'true')
    script.onerror = () => {
      console.error('Failed to load HubSpot chat script')
    }
    document.body.appendChild(script)
  } catch (err) {
    console.error('Error loading HubSpot chat:', err)
  }
}

let loadGTMScript = false
export function loadGtmScript(GTM_ID: string) {
  if (!GTM_ID || loadGTMScript) {
    return
  }

  // Initialize the data layer with default events if it doesn't already exist
  // Type assertion for the data layer
  window['dataLayer'] = window['dataLayer'] || []
  window['dataLayer'].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  })
  ;(function (
    w: {[key: string]: Array<Record<string, string | number>>},
    d: Document,
    s: 'script',
    l: string,
    i: string
  ) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement<'script'>(s)
    const dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode?.insertBefore(j, f)
    // @ts-expect-error window is not properly typed
  })(window, document, 'script', 'dataLayer', GTM_ID)

  loadGTMScript = true
}

let metaPixelLoaded = false
export function loadMetaPixelScript(PIXEL_ID: string) {
  if (!PIXEL_ID || metaPixelLoaded) return

  if (typeof window !== 'undefined') {
    const fbqFunction = function (...args: unknown[]) {
      ;(fbqFunction.q = fbqFunction.q || []).push(args)
    } as {
      (...args: unknown[]): void
      q: unknown[][]
      loaded: boolean
      version: string
      queue: unknown[][]
    }

    fbqFunction.loaded = true
    fbqFunction.version = '2.0'
    fbqFunction.queue = []

    window.fbq = fbqFunction

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onerror = () => {
      console.error('Failed to load Meta Pixel script')
    }

    document.head.appendChild(script)

    fbqFunction('init', PIXEL_ID)
    fbqFunction('track', 'PageView')

    metaPixelLoaded = true
  }
}

export function trackMetaPixelEvent(eventName: string, parameters?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.fbq) {
    if (parameters) {
      window.fbq('track', eventName, parameters)
    } else {
      window.fbq('track', eventName)
    }
  }
}

let linkedInPixelLoaded = false
export function loadLinkedInPixelScript(PIXEL_ID: string) {
  if (!PIXEL_ID || linkedInPixelLoaded) return

  if (typeof window !== 'undefined') {
    window._linkedin_partner_id = PIXEL_ID
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
    window._linkedin_data_partner_ids.push(PIXEL_ID)

    if (!window.lintrk) {
      const lintrkFunction = function (a: string, b?: unknown) {
        lintrkFunction.q = lintrkFunction.q || []
        lintrkFunction.q.push([a, b])
      } as {
        (command: string, ...args: unknown[]): void
        q: unknown[][]
      }
      lintrkFunction.q = []
      window.lintrk = lintrkFunction
    }

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
    script.onerror = () => {
      console.error('Failed to load LinkedIn Pixel script')
    }

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.body.appendChild(script)
    }

    linkedInPixelLoaded = true
  }
}

export function trackLinkedInPixelEvent(eventName: string, parameters?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.lintrk) {
    if (parameters) {
      window.lintrk('track', eventName, parameters)
    } else {
      window.lintrk('track', eventName)
    }
  }
}
